import DevicesAndLicensesCard from './DevicesAndLicensesCard';

export default DevicesAndLicensesCard;
